import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "hr-page user-list-page" }
const _hoisted_2 = { class: "console-page-head" }
const _hoisted_3 = { class: "console-head-side" }
const _hoisted_4 = { class: "console-count" }
const _hoisted_5 = { class: "hr-body" }
const _hoisted_6 = { class: "hr-main-layout" }
const _hoisted_7 = { class: "content-card" }
const _hoisted_8 = { class: "user-filter" }
const _hoisted_9 = { class: "user-filter-search" }
const _hoisted_10 = { class: "user-filter-role" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "user-filter-status" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "row-num" }
const _hoisted_15 = { class: "user-name-cell" }
const _hoisted_16 = { class: "info" }
const _hoisted_17 = { class: "name-text" }
const _hoisted_18 = { class: "id-text" }
const _hoisted_19 = { class: "org-text" }
const _hoisted_20 = { class: "role-pill" }
const _hoisted_21 = { class: "contact-info" }
const _hoisted_22 = {
  key: 0,
  class: "phone"
}
const _hoisted_23 = {
  key: 1,
  class: "email"
}
const _hoisted_24 = {
  key: 2,
  class: "empty"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "user-edit-head" }
const _hoisted_28 = { class: "user-edit-head-text" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "user-edit-loading"
}
const _hoisted_32 = { class: "console-field" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "console-field" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "console-field" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "user-edit-split" }
const _hoisted_39 = { class: "console-field" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "console-field" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "console-field" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "user-edit-actions" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]

import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { userApi, authApi } from '@/services/api';
import TablePagination from '@/components/common/TablePagination.vue';
import DeleteConfirmDialog from '@/components/common/DeleteConfirmDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserList',
  setup(__props) {

const store = useStore();
const router = useRouter();

const currentUser = computed(() => store.getters.currentUser);
const userOrgCode = computed(() => store.getters.orgCode);
const userRoleLevel = computed(() => store.getters.roleLevel);
const actualRoleLevel = computed(() => store.getters.actualRoleLevel);
const canImpersonateUser = computed(() => store.getters.canImpersonateUser);

// 관리자(60+) 여부 - 유저 등록/삭제, 대리 로그인, 상세 통계 표시 여부 결정
const isAdmin = computed(() => actualRoleLevel.value >= 60);

// 해당 유저를 수정할 수 있는지 확인 (같거나 높은 권한은 수정 불가, 어드민 90+는 제한 없음)
const canEditUser = (item: any) => {
  if (actualRoleLevel.value >= 90) return true;
  return (item.role_level || 0) < actualRoleLevel.value;
};

// 상태
const loading = ref(false);
const userList = ref<any[]>([]);
const totalCount = ref(0);
const currentPage = ref(1);
const itemsPerPage = ref(50);
const searchText = ref('');
const selectedRoleCode = ref('');
const selectedStatus = ref<number | string>(1); // 기본값: 활성
const roleList = ref<any[]>([]);

// 수정 가능한 권한 목록 (자기보다 낮은 권한만)
const editableRoleList = computed(() => {
  if (actualRoleLevel.value >= 90) return roleList.value;
  return roleList.value.filter((r: any) => (r.role_level || 0) < actualRoleLevel.value);
});

// 권한 옵션 (전체 포함)
const roleOptions = computed(() => {
  const options = [{ role_name: '전체', role_code: '', role_color: '' }];
  return options.concat(roleList.value);
});

// 적용된 필터 개수
const filterCount = computed(() => {
  let count = 0;
  if (selectedRoleCode.value) count++;
  if (selectedStatus.value !== '') count++;
  if (searchText.value) count++;
  return count;
});

// 필터 적용 여부
const hasActiveFilters = computed(() => filterCount.value > 0);

// 권한명 가져오기
const getRoleName = (roleCode: string) => {
  const role = roleList.value.find(r => r.role_code === roleCode);
  return role?.role_name || roleCode;
};
const editDialog = ref(false);
const editLoading = ref(false);
const editSaving = ref(false);
const editForm = ref({
  u_idx: 0,
  u_id: '',
  u_name: '',
  u_email: '',
  u_phone: '',
  u_role_code: '',
  u_status: 1,
  role_level: 0,
  u_pw: ''
});

const editingSelf = computed(() => editForm.value.u_idx === currentUser.value?.idx);
const canSaveEdit = computed(() => canEditUser(editForm.value) || editingSelf.value);
const canChangeRole = computed(() => canEditUser(editForm.value) && !editingSelf.value);
const canDeleteEdit = computed(() => isAdmin.value && canEditUser(editForm.value) && !editingSelf.value);
const editRoleOptions = computed(() => {
  const current = roleList.value.find((role: any) => role.role_code === editForm.value.u_role_code);
  const options = editableRoleList.value.slice();
  if (current && !options.some((role: any) => role.role_code === current.role_code)) {
    options.unshift(current);
  }
  return options;
});

// 로그인 기록
const loginHistory = ref<any[]>([]);
const loginHistoryLoading = ref(false);

// 인라인 편집
const editingField = ref<string | null>(null);
const editingUser = ref<any>(null);
const editValue = ref<any>('');

// 유저 생성/삭제
const createDialog = ref(false);
const deleteDialog = ref(false);
const deleteTarget = ref<any>(null);

const newUser = ref({
  u_id: '',
  u_pw: '',
  u_name: '',
  u_email: '',
  u_phone: '',
  u_org_code: null as string | null,
  u_role_code: 'MANAGER',
  u_status: 1
});
const createLoading = ref(false);
const deleteLoading = ref(false);

const statusOptions = [
  { text: '전체', value: '' },
  { text: '활성', value: 1 },
  { text: '비활성', value: 0 }
];

const headers = [
  { title: 'No', key: 'index', sortable: false, align: 'center' as const, width: '56px' },
  { title: '이름', key: 'u_name', sortable: false, width: '200px' },
  { title: '소속', key: 'org_info', sortable: false, width: '140px' },
  { title: '권한', key: 'role_name', sortable: false, width: '120px' },
  { title: '연락처', key: 'contact', sortable: false },
  { title: '상태', key: 'u_status', sortable: false, align: 'center' as const, width: '80px' },
  { title: '최근 로그인', key: 'u_last_login', sortable: false, width: '120px' },
  { title: '', key: 'actions', sortable: false, align: 'end' as const, width: '160px' }
];

const totalPages = computed(() => Math.ceil(totalCount.value / itemsPerPage.value));

// 유저 목록 조회
const fetchUserList = async () => {
  loading.value = true;
  try {
    const response = await userApi.getList({
      search: searchText.value || undefined,
      roleCode: selectedRoleCode.value || undefined,
      status: selectedStatus.value !== '' ? selectedStatus.value : undefined,
      orgCode: userOrgCode.value,
      roleLevel: userRoleLevel.value,
      page: currentPage.value,
      limit: itemsPerPage.value
    });

    if (response.data.success) {
      userList.value = response.data.data;
      totalCount.value = response.data.pagination.total;
    }
  } catch (error) {
    console.error('유저 목록 조회 오류:', error);
    store.dispatch('showError', '유저 목록을 불러오는데 실패했습니다.');
  } finally {
    loading.value = false;
  }
};

// 권한 목록 조회
const fetchRoleList = async () => {
  try {
    const response = await authApi.getRoles();
    if (response.data.success) {
      roleList.value = response.data.data;
    }
  } catch (error) {
    console.error('권한 목록 조회 오류:', error);
  }
};

const clearRoleFilter = () => {
  selectedRoleCode.value = '';
  currentPage.value = 1;
  fetchUserList();
};

const clearStatusFilter = () => {
  selectedStatus.value = '';
  currentPage.value = 1;
  fetchUserList();
};

const clearSearchFilter = () => {
  searchText.value = '';
  currentPage.value = 1;
  fetchUserList();
};

const clearAllFilters = () => {
  selectedRoleCode.value = '';
  selectedStatus.value = '';
  searchText.value = '';
  currentPage.value = 1;
  fetchUserList();
};

const onClearSearch = () => {
  searchText.value = '';
  currentPage.value = 1;
  fetchUserList();
};

const searchUsers = () => {
  currentPage.value = 1;
  fetchUserList();
};

const setStatus = (value: number | string) => {
  if (selectedStatus.value === value) return;
  selectedStatus.value = value;
  searchUsers();
};

const rowProps = (data: { item: any }) => ({
  class: data.item.u_status !== 1 ? 'is-inactive' : ''
});

const onRowClick = (_event: Event, row: { item: any }) => {
  openEdit(row.item);
};

const onPageChange = () => fetchUserList();
const onItemsPerPageChange = () => {
  currentPage.value = 1;
  fetchUserList();
};

const openEdit = async (user: any) => {
  editDialog.value = true;
  editLoading.value = true;
  editForm.value = {
    u_idx: user.u_idx,
    u_id: user.u_id || '',
    u_name: user.u_name || '',
    u_email: user.u_email || '',
    u_phone: user.u_phone || '',
    u_role_code: user.u_role_code || '',
    u_status: user.u_status ?? 1,
    role_level: user.role_level || 0,
    u_pw: ''
  };
  try {
    const response = await userApi.getById(user.u_idx);
    if (response.data.success) {
      const data = response.data.data;
      editForm.value = {
        u_idx: data.u_idx,
        u_id: data.u_id || '',
        u_name: data.u_name || '',
        u_email: data.u_email || '',
        u_phone: data.u_phone || '',
        u_role_code: data.u_role_code || '',
        u_status: data.u_status ?? 1,
        role_level: data.role_level || 0,
        u_pw: ''
      };
    }
  } catch (error) {
    store.dispatch('showError', '직원 정보를 불러오지 못했습니다.');
    editDialog.value = false;
  } finally {
    editLoading.value = false;
  }
};

const saveEdit = async () => {
  if (!canSaveEdit.value || !editForm.value.u_name.trim()) {
    store.dispatch('showError', '이름을 입력하세요.');
    return;
  }
  editSaving.value = true;
  try {
    const payload: Record<string, unknown> = {
      u_name: editForm.value.u_name.trim(),
      u_email: editForm.value.u_email.trim(),
      u_phone: editForm.value.u_phone.trim()
    };
    if (canChangeRole.value) {
      payload.u_role_code = editForm.value.u_role_code;
      payload.u_status = editForm.value.u_status;
    }
    if (editForm.value.u_pw.trim()) payload.u_pw = editForm.value.u_pw.trim();
    await userApi.update(editForm.value.u_idx, payload, actualRoleLevel.value);
    store.dispatch('showSuccess', '저장되었습니다.');
    editDialog.value = false;
    fetchUserList();
  } catch (error: any) {
    store.dispatch('showError', error.response?.data?.message || '저장에 실패했습니다.');
  } finally {
    editSaving.value = false;
  }
};

const formatDate = (dateStr: string) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

const formatDateTime = (dateStr: string) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  
  if (days === 0) return '오늘 ' + `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  if (days === 1) return '어제';
  if (days < 7) return `${days}일 전`;
  
  return formatDate(dateStr);
};

const isRecentLogin = (dateStr: string) => {
  if (!dateStr) return false;
  const diff = new Date().getTime() - new Date(dateStr).getTime();
  return diff < 24 * 60 * 60 * 1000; // 24시간 이내
};

// 전체 날짜/시간 포맷 (로그인 기록용)
const formatFullDateTime = (dateStr: string) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${m}-${d} ${h}:${min}:${s}`;
};

// 로그인 기록 로드
const loadLoginHistory = async (user: any) => {
  loginHistoryLoading.value = true;
  loginHistory.value = [];
  
  try {
    const response = await authApi.getRecentLogins('user', user.u_idx, 10);
    if (response.data.success) {
      loginHistory.value = response.data.data;
    }
  } catch (error) {
    console.error('로그인 기록 조회 오류:', error);
  } finally {
    loginHistoryLoading.value = false;
  }
};

const getRoleColor = (roleCode: string) => {
  const role = roleList.value.find(r => r.role_code === roleCode);
  return role?.role_color || '#9e9e9e';
};

const getRoleClass = (roleLevel: number) => {
  if (roleLevel >= 90) return 'super';
  if (roleLevel >= 60) return 'admin';
  if (roleLevel >= 50) return 'manager';
  return 'staff';
};

// 필드 저장 (인라인 편집)
const saveUserField = async (user: any, field: string) => {
  try {
    let updateData: any = {};
    
    if (field === 'contact') {
      updateData = { u_email: user.u_email, u_phone: user.u_phone };
    } else {
      updateData = { [field]: user[field] };
    }
    
    await userApi.update(user.u_idx, updateData, actualRoleLevel.value);
    store.dispatch('showSuccess', '저장되었습니다.');
    fetchUserList();
  } catch (error: any) {
    console.error('저장 오류:', error);
    store.dispatch('showError', error.response?.data?.message || '저장에 실패했습니다.');
  }
};

// 유저 생성 다이얼로그 열기
const openCreateDialog = () => {
  newUser.value = {
    u_id: '',
    u_pw: '',
    u_name: '',
    u_email: '',
    u_phone: '',
    u_org_code: null,
    u_role_code: 'MANAGER',
    u_status: 1
  };
  createDialog.value = true;
};

// 유저 생성
const createUser = async () => {
  if (!newUser.value.u_id || !newUser.value.u_pw || !newUser.value.u_name) {
    store.dispatch('showError', '필수 항목을 입력해주세요.');
    return;
  }
  
  createLoading.value = true;
  try {
    await userApi.create(newUser.value);
    store.dispatch('showSuccess', '유저가 등록되었습니다.');
    createDialog.value = false;
    fetchUserList();
  } catch (error: any) {
    console.error('유저 생성 오류:', error);
    store.dispatch('showError', error.response?.data?.message || '유저 등록에 실패했습니다.');
  } finally {
    createLoading.value = false;
  }
};

// 삭제 확인
const confirmDelete = (user: any) => {
  deleteTarget.value = user;
  deleteDialog.value = true;
};

// 유저 삭제
const deleteUser = async () => {
  if (!deleteTarget.value) return;
  
  deleteLoading.value = true;
  try {
    await userApi.delete(deleteTarget.value.u_idx, actualRoleLevel.value);
    store.dispatch('showSuccess', '유저가 삭제되었습니다.');
    deleteDialog.value = false;
    deleteTarget.value = null;
    editDialog.value = false;
    fetchUserList();
  } catch (error: any) {
    console.error('유저 삭제 오류:', error);
    store.dispatch('showError', error.response?.data?.message || '유저 삭제에 실패했습니다.');
  } finally {
    deleteLoading.value = false;
  }
};

// 대리 로그인 실행 (바로 접속)
const doImpersonate = (target: any) => {
  const role = roleList.value.find((r: any) => r.role_code === target.u_role_code);
  
  // AuthUser 형식으로 변환
  const targetUser = {
    idx: target.u_idx,
    id: target.u_id,
    name: target.u_name,
    email: target.u_email || '',
    phone: target.u_phone || '',
    orgCode: target.u_org_code || '',
    orgName: target.org_name || '',
    orgLevel: target.org_level || '',
    roleCode: target.u_role_code,
    roleName: role?.role_name || target.role_name || '',
    roleLevel: role?.role_level || target.role_level || 0,
    userType: 'user' as const,
    lastLogin: target.u_last_login
  };
  
  store.dispatch('impersonate', targetUser);
  
  // 페이지 새로고침하여 권한에 맞는 데이터 로드
  router.go(0);
};

onMounted(() => {
  fetchUserList();
  fetchRoleList();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "console-page-copy" }, [
        _createElementVNode("p", { class: "console-kicker" }, "조직"),
        _createElementVNode("h2", { class: "console-title" }, "인사관리")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "직원 " + _toDisplayString(totalCount.value) + "명", 1),
        (isAdmin.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              size: "small",
              variant: "flat",
              class: "btn-register",
              onClick: openCreateDialog
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "small",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[26] || (_cache[26] = _createTextVNode(" 유저 등록 ", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode("mdi-magnify", -1)
                ]))]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                type: "text",
                placeholder: "이름, 아이디, 이메일",
                onKeydown: _withKeys(searchUsers, ["enter"])
              }, null, 544), [
                [_vModelText, searchText.value]
              ]),
              (searchText.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "user-filter-clear",
                    onClick: onClearSearch
                  }, "지우기"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("label", _hoisted_10, [
              _cache[29] || (_cache[29] = _createElementVNode("span", null, "권한", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRoleCode).value = $event)),
                onChange: searchUsers
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleOptions.value, (role) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: role.role_code || 'all',
                    value: role.role_code
                  }, _toDisplayString(role.role_name), 9, _hoisted_11))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedRoleCode.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (opt) => {
                return _createElementVNode("button", {
                  key: String(opt.value),
                  type: "button",
                  class: _normalizeClass({ active: selectedStatus.value === opt.value }),
                  onClick: ($event: any) => (setStatus(opt.value))
                }, _toDisplayString(opt.text), 11, _hoisted_13)
              }), 64))
            ])
          ]),
          _createVNode(_component_v_data_table, {
            headers: headers,
            items: userList.value,
            loading: loading.value,
            "items-per-page": -1,
            hover: "",
            class: "user-table",
            "row-props": rowProps,
            "onClick:row": onRowClick
          }, {
            "item.index": _withCtx(({ index }) => [
              _createElementVNode("span", _hoisted_14, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + index + 1), 1)
            ]),
            "item.u_name": _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass(["avatar", getRoleClass(item.role_level)])
                }, _toDisplayString(item.u_name?.charAt(0)), 3),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.u_name), 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.u_id), 1)
                ])
              ])
            ]),
            "item.org_info": _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_19, _toDisplayString(item.org_name || '—'), 1)
            ]),
            "item.role_name": _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_20, [
                _createElementVNode("span", {
                  class: "dot",
                  style: _normalizeStyle({ background: getRoleColor(item.u_role_code) })
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(item.role_name || '—'), 1)
              ])
            ]),
            "item.contact": _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_21, [
                (item.u_phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.u_phone), 1))
                  : _createCommentVNode("", true),
                (item.u_email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.u_email), 1))
                  : _createCommentVNode("", true),
                (!item.u_phone && !item.u_email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "연락처 없음"))
                  : _createCommentVNode("", true)
              ])
            ]),
            "item.u_status": _withCtx(({ item }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["user-state", item.u_status === 1 ? 'is-on' : 'is-off'])
              }, _toDisplayString(item.u_status === 1 ? '활성' : '비활성'), 3)
            ]),
            "item.u_last_login": _withCtx(({ item }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["last-login", { recent: isRecentLogin(item.u_last_login) }])
              }, _toDisplayString(formatDateTime(item.u_last_login)), 3)
            ]),
            "item.actions": _withCtx(({ item }) => [
              _createElementVNode("div", {
                class: "action-btns",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                (isAdmin.value && canImpersonateUser.value && item.u_idx !== currentUser.value?.idx)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "row-action",
                      onClick: ($event: any) => (doImpersonate(item))
                    }, " 접속 ", 8, _hoisted_25))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "row-action",
                  onClick: ($event: any) => (openEdit(item))
                }, "수정", 8, _hoisted_26)
              ])
            ]),
            "no-data": _withCtx(() => [...(_cache[30] || (_cache[30] = [
              _createElementVNode("div", { class: "empty-message" }, [
                _createElementVNode("p", null, "등록된 직원이 없습니다.")
              ], -1)
            ]))]),
            bottom: _withCtx(() => [
              _createVNode(TablePagination, {
                "current-page": currentPage.value,
                "onUpdate:currentPage": [
                  _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
                  onPageChange
                ],
                "items-per-page": itemsPerPage.value,
                "onUpdate:itemsPerPage": [
                  _cache[4] || (_cache[4] = ($event: any) => ((itemsPerPage).value = $event)),
                  onItemsPerPageChange
                ],
                "total-count": totalCount.value,
                "total-pages": totalPages.value
              }, null, 8, ["current-page", "items-per-page", "total-count", "total-pages"])
            ]),
            _: 1
          }, 8, ["items", "loading"])
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: editDialog.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editDialog).value = $event)),
      "max-width": "520px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "user-edit-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[31] || (_cache[31] = _createElementVNode("h3", null, "직원 수정", -1)),
                (editForm.value.u_id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(editForm.value.u_id), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "user-edit-dialog__close",
                disabled: editSaving.value,
                "aria-label": "닫기",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (editDialog.value = false))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ], 8, _hoisted_30)
            ]),
            (editLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, "불러오는 중"))
              : (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  class: "user-edit-form",
                  onSubmit: _withModifiers(saveEdit, ["prevent"])
                }, [
                  _createElementVNode("label", _hoisted_32, [
                    _cache[33] || (_cache[33] = _createElementVNode("span", null, "이름", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.u_name) = $event)),
                      type: "text",
                      disabled: !canSaveEdit.value
                    }, null, 8, _hoisted_33), [
                      [_vModelText, editForm.value.u_name]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_34, [
                    _cache[34] || (_cache[34] = _createElementVNode("span", null, "이메일", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.u_email) = $event)),
                      type: "text",
                      disabled: !canSaveEdit.value
                    }, null, 8, _hoisted_35), [
                      [_vModelText, editForm.value.u_email]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_36, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", null, "연락처", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editForm.value.u_phone) = $event)),
                      type: "text",
                      disabled: !canSaveEdit.value
                    }, null, 8, _hoisted_37), [
                      [_vModelText, editForm.value.u_phone]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, [
                      _cache[36] || (_cache[36] = _createElementVNode("span", null, "권한", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.u_role_code) = $event)),
                        disabled: !canChangeRole.value
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editRoleOptions.value, (role) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: role.role_code,
                            value: role.role_code
                          }, _toDisplayString(role.role_name), 9, _hoisted_41))
                        }), 128))
                      ], 8, _hoisted_40), [
                        [_vModelSelect, editForm.value.u_role_code]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_42, [
                      _cache[38] || (_cache[38] = _createElementVNode("span", null, "상태", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editForm.value.u_status) = $event)),
                        disabled: !canChangeRole.value
                      }, [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("option", { value: 1 }, "활성", -1),
                        _createElementVNode("option", { value: 0 }, "비활성", -1)
                      ]))], 8, _hoisted_43), [
                        [
                          _vModelSelect,
                          editForm.value.u_status,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_44, [
                    _cache[39] || (_cache[39] = _createElementVNode("span", null, "비밀번호", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.u_pw) = $event)),
                      type: "password",
                      placeholder: "바꾸지 않으면 비워 두세요",
                      disabled: !canSaveEdit.value
                    }, null, 8, _hoisted_45), [
                      [_vModelText, editForm.value.u_pw]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    (canDeleteEdit.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "user-edit-delete",
                          disabled: editSaving.value || deleteLoading.value,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (confirmDelete(editForm.value)))
                        }, " 삭제 ", 8, _hoisted_47))
                      : _createCommentVNode("", true),
                    _cache[40] || (_cache[40] = _createElementVNode("span", { class: "user-edit-spacer" }, null, -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "user-edit-cancel",
                      disabled: editSaving.value,
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (editDialog.value = false))
                    }, "취소", 8, _hoisted_48),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "user-edit-save",
                      disabled: !canSaveEdit.value || editSaving.value
                    }, _toDisplayString(editSaving.value ? '저장 중' : '저장'), 9, _hoisted_49)
                  ])
                ], 32))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: createDialog.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((createDialog).value = $event)),
      "max-width": "500px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "create-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-header-simple" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                    _createTextVNode("mdi-account-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[43] || (_cache[43] = _createTextVNode(" 유저 등록 ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "create-dialog__close",
                  disabled: createLoading.value,
                  "aria-label": "닫기",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (createDialog.value = false))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_50)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "create-dialog-body" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  onSubmit: _withModifiers(createUser, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: newUser.value.u_id,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newUser.value.u_id) = $event)),
                              label: "아이디 *",
                              variant: "outlined",
                              density: "compact",
                              rules: [v => !!v || '아이디를 입력하세요']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: newUser.value.u_pw,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newUser.value.u_pw) = $event)),
                              label: "비밀번호 *",
                              type: "password",
                              variant: "outlined",
                              density: "compact",
                              rules: [v => !!v || '비밀번호를 입력하세요']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: newUser.value.u_name,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newUser.value.u_name) = $event)),
                              label: "이름 *",
                              variant: "outlined",
                              density: "compact",
                              rules: [v => !!v || '이름을 입력하세요']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: newUser.value.u_role_code,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newUser.value.u_role_code) = $event)),
                              items: roleList.value,
                              "item-title": "role_name",
                              "item-value": "role_code",
                              label: "권한 *",
                              variant: "outlined",
                              density: "compact"
                            }, {
                              item: _withCtx(({ props, item }) => [
                                _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                  prepend: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: "color-dot",
                                      style: _normalizeStyle({ background: item.raw.role_color })
                                    }, null, 4)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: newUser.value.u_email,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((newUser.value.u_email) = $event)),
                              label: "이메일",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: newUser.value.u_phone,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((newUser.value.u_phone) = $event)),
                              label: "전화번호",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (createDialog.value = false)),
                  disabled: createLoading.value
                }, {
                  default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-register",
                  onClick: createUser,
                  loading: createLoading.value
                }, {
                  default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                    _createTextVNode("등록", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(DeleteConfirmDialog, {
      modelValue: deleteDialog.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((deleteDialog).value = $event)),
      title: "유저 삭제",
      "target-name": `${deleteTarget.value?.u_name || ''} (${deleteTarget.value?.u_id || ''})`,
      message: "유저를 삭제하시겠습니까?",
      loading: deleteLoading.value,
      onConfirm: deleteUser
    }, null, 8, ["modelValue", "target-name", "loading"])
  ]))
}
}

})